<template>
  <div class="main_con">
    <top-header :type="9" :placeholder="'请输入机构名称'" @comfirmText="comfirmText" />
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="m_flex_box flex_vc inner" v-for="(item, index) in list" :key="index">
            <div class="left">
              <img src="" alt="" v-lazy="item.url">
            </div>
            <div class="right">
              <h3 class="line_comp1">{{item.bankName}}</h3>
              <p class="address line_comp1">监管支行数：<span>{{item.branchesNum}}</span></p>
              <p class="address line_comp1">监管项目数：<span>{{item.itemNum}}</span></p>
              <div class="m_flex_box flex_vc flex_jz">
                <p class="address line_comp1 no_mar">监管预售数：<span>{{item.saleItemNum}}</span></p>
                <router-link :to="{path:'/otherSupervision',query:{xzqh:item.area,bankNo:item.bankNo}}">监管项目>></router-link>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import topHeader from '@/components/header'
import qs from "qs";
export default {
  name: 'FundList',
  data() {
    return {
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      bankName:'',
    };
  },
  components: {
    topHeader
  },
  mounted() {},
  methods: {
    comfirmText(data) {
      this.bankName = data;
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.onLoad();
    },

    onRefresh() {
      this.finished = false;
      this.$set(this, 'list', []);
      this.onLoad(1)
    },
    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$new.post('saleSpv/getJgBankList.do', qs.stringify({
          bankName: this.bankName,
          xzqh: this.main.getHostArea()
        })).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if(res.success) {
            this.$set(this, 'list', res.obj);
            this.loading = false;
            this.loading = false;
            this.finished = true;
          }
        })
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'otherSupervision'){
      this.$store.dispatch('saveView', ['FundList']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .list{
    width: 7.04rem;
    margin: 0 auto;
    .inner{
      border-bottom: 1px solid #F4F4F4;
      padding: 0.34rem;
      .left{
        width: 2.14rem;
        height: 1.6rem;
        box-sizing: border-box;
        border: 1px solid #f4f4f4;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .right{
        width: 4rem;
        margin-left: 0.2rem;
        h3{
          font-size: 0.3rem;
          font-weight: 600;
          margin-bottom: 0.14rem;
        }
        .address{
          font-size: 0.24rem;
          color: #202020;
          margin-bottom: 0.08rem;
          span{
            color: #909090;
          }
          &.no_mar{
            margin-bottom: 0;
          }
        }
        a{
          color: #2388EC;
          font-size: 0.26rem;
        }
      }
    }
  }
</style>